import { requestShareDetailApi } from '@/api/common';
import { getUrlParams } from '@/utils';

interface IShareOptions {
  shareId: string;
  shareUserId?: string;
  extraInfo?: any;
}

class AppModel {
  shareInfo: any = Object.create(null);

  shareId: string = '';

  shareUserId: string = '';

  extraInfo = Object.create(null);

  private requestShareInfoPromise: Promise<any> | null = null;

  hasGetShareInfo = false;

  init() {
    const { shareId } = getUrlParams(window.location.href || '');
    if (!shareId) return;
    this.shareId = shareId;
    const options = {
      shareId,
    };
    this.requestShareInfoPromise = this.requestShareInfo(options);
  }

  async requestShareInfo(options: IShareOptions) {
    const { shareId } = options;

    return new Promise<IShareOptions>(async (resolve, reject) => {
      try {
        const res = await requestShareDetailApi({
          shareId,
        }).catch(() => null);

        if (!res || !res.data || !res.data.extraInfo) {
          // 处理请求失败或数据缺失的情况
          console.log('appModel: API请求失败或数据缺失，返回空的 extraInfo');
          resolve({
            shareId,
            shareUserId: '',
            extraInfo: {},
          });
          return;
        }

        const { extraInfo, shareUserId } = res?.data || {};
        this.extraInfo = JSON.parse(extraInfo as string);
        this.shareUserId = shareUserId || '';
        this.hasGetShareInfo = true;
        resolve({
          shareId,
          shareUserId,
          extraInfo: JSON.parse(extraInfo as string),
        });
      } catch (error) {
        // 捕获并处理 JSON.parse 可能抛出的异常
        reject(error);
      }
    });
  }

  onShareInfoReady() {
    if (!this.shareId) {
      console.log('appModel: 没有找到 shareId，返回空的 extraInfo');
      return Promise.resolve({
        shareId: '',
        shareUserId: '',
        extraInfo: {},
      });
    }
    if (this.hasGetShareInfo) {
      return Promise.resolve({
        shareId: this.shareId,
        shareUserId: this.shareUserId,
        extraInfo: this.extraInfo,
      });
    }
    if (this.requestShareInfoPromise === null) {
      this.requestShareInfoPromise = this.requestShareInfo({
        shareId: this.shareId,
      });
    }
    return this.requestShareInfoPromise;
  }
}

export default new AppModel();
